<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" class="pa-4" v-if="showTitle">
    <v-card flat>
      <v-card-title>
        Templates
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Suche"
        single-line
        hide-details
        ></v-text-field>
      </v-card-title>
    </v-card>
    </v-col>
    <v-col cols="12" xs="12" class="pa-4">
      <v-data-table
          :headers="headers"
          :items="deviceList"
          :search="search"
          fixed-header
          :height="tableHeight"
          hide-default-footer
          hide-details
          :items-per-page="-1"
          @click:row="editItem"
      >

        <template v-slot:item.name="{ item }">
          <span>
            {{item.name}}
          </span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2"  @click.stop="download(item)">cloud_download</v-icon>
          <v-icon
              small
              class="mr-2"
              @click.stop="editItem(item)"
          >
            edit
          </v-icon>
          <v-icon
              small
              @click.stop="deleteItem(item)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>

    </v-col>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

export default {
  name: 'TableUser',
  props: {
    showTitle: Boolean
  },
  components: {DialogDeleteItem},
  methods: {

    resize: function () {
      this.tableHeight = window.innerHeight - 404;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 304;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Template',
        id: '' + item.guid,
        name: 'Template ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item)
      Vue.prototype.$apiTemplate.deleteItem(item.item.guid, this.reload)
    },
    editItem: function (item) {
        this.$router.push('/Templates/' + item.guid)
    },
    download: function (item) {
      console.log('item', item)
      Vue.prototype.$apiTemplate.downloadFiles(item.guid)
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.companyName) {
        style = 'color: #aa4444;'
      }
      return style
    },
    reload: function () {
      var reqData = {}
      if (this.companyId != null) {
        reqData.guidParent = this.companyId
      }
      Vue.prototype.$apiTemplate.load(reqData, this.onGetData)
    },
    onGetData: function (result) {
      this.deviceList = result
    }
  },
  data () {
    return {
      currentDevice: null,
      search: null,
      tableHeight: 100,
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Beschreibung', value: 'comment'},
        {text: 'Aktion', value: 'action'}
      ],
      deviceList: []
    }
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
    this.resize()
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)

  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  }
}
</script>

<style scoped>

</style>
